import React from 'react';
import {
  Link,
  useCreatePath,
  useResourceContext,
} from 'react-admin';

import {
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const EditToolbar = ({
  children,
  backButtonLabel,
  backState,
}: {
  children?: React.ReactNode;
  backButtonLabel?: string;
  backState?: any;
}) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const resource = useResourceContext();
  const createPath = useCreatePath();

  const listView = createPath({ resource, type: 'list' });

  return (
    <Box display="flex" justifyContent="space-between" flexWrap="wrap">
      <Box display="flex" alignItems="center" gap={1}>
        {backButtonLabel && !isTablet ? (
          <Button
            size="small"
            component={Link}
            to={listView}
            state={backState}
            startIcon={<ArrowBackIosIcon color="primary" fontSize="inherit" />}
            variant="text"
          >
            <Typography variant="h5">{backButtonLabel}</Typography>
          </Button>
        ) : (
          <IconButton
            component={Link}
            to={listView}
            state={backState}
            size="small"
          >
            <ArrowBackIosIcon color="primary" fontSize="inherit" />
          </IconButton>
        )}
      </Box>
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
        {children}
      </Box>
    </Box>
  );
};

export default EditToolbar;
